import { IRootState } from '../store';

import { createSelector } from 'reselect';
import { IOption } from '../../components/UIWidgets/Autocomplete';

export function getCurrency(state: IRootState): ICurrency[] {
  return state.currency.data;
}

export const getCurrencyOptions = createSelector<IRootState, ICurrency[], Array<IOption<ICurrency>>>(
  getCurrency,
  (currencyList: ICurrency[]): Array<IOption<ICurrency>> => {
    return currencyList.map((currency) => {
      return {
        id: currency.id,
        value: currency,
        name: currency.name,
      };
    });
  }
);
